// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
const InboxConstants = Marty.createConstants([
  'INBOX_LIST_FETCH',
  'INBOX_FETCH',
  'INBOX_UPDATE',
  'INBOX_CREATE',
  'INBOX_ARCHIVE',
  'CHECK_INBOX_EXISTENCE_BY_EMAIL',
  'WHITE_LIST_LABELS_CREATE',
  'WHITE_LIST_LABELS_FETCH',
  'WHITE_LIST_LABELS_VALIDATE'
])

export default InboxConstants




// WEBPACK FOOTER //
// ./src/scripts/constants/InboxConstants.js